"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = require("styled-components");

var react_router_dom_1 = require("react-router-dom");

var React = require("react");

var palette_1 = require("../../constants/palette");

var TabLinkListItem = styled_components_1.default.li(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: table;\n  height: 100%;\n"], ["\n  display: table;\n  height: 100%;\n"])));
var TabLinkAnchor = styled_components_1.default(react_router_dom_1.NavLink)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-decoration: none;\n  color: ", ";\n  font-size: 16px;\n  height: 100%;\n  display: table-cell;\n  vertical-align: middle;\n  padding-left: 15px;\n  padding-right: 15px;\n  transition: .2s color ease-in;\n  border-bottom: 3px solid;\n  border-color: transparent;\n  &.active {\n    border-bottom: 3px solid;\n    border-color: ", ";\n    color: ", ";\n  }\n  &:hover {\n    color: ", ";\n  }\n"], ["\n  text-decoration: none;\n  color: ", ";\n  font-size: 16px;\n  height: 100%;\n  display: table-cell;\n  vertical-align: middle;\n  padding-left: 15px;\n  padding-right: 15px;\n  transition: .2s color ease-in;\n  border-bottom: 3px solid;\n  border-color: transparent;\n  &.active {\n    border-bottom: 3px solid;\n    border-color: ", ";\n    color: ", ";\n  }\n  &:hover {\n    color: ", ";\n  }\n"])), palette_1.default.medGrey, function (props) {
  return props.theme.primary;
}, palette_1.default.black, palette_1.default.black);

var TabLink = function TabLink(props) {
  return React.createElement(TabLinkListItem, null, React.createElement(TabLinkAnchor, {
    to: props.link,
    exact: true
  }, props.text));
};

exports.default = TabLink;
var templateObject_1, templateObject_2;